import { render } from "./next_level_form.vue?vue&type=template&id=98560280"
import script from "./next_level_form.vue?vue&type=script&lang=js"
export * from "./next_level_form.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__